import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

export function useForms({
  validator,
  mode = "onSubmit",
  reValidateMode = "onSubmit",
}) {
  const data = useForm({
    resolver: zodResolver(validator),
    mode,
    reValidateMode,
  });

  return data;
}
